import React, {useEffect, useState} from "react"
import {TbDots} from "react-icons/tb";
import {DeleteIcon, EditIcon} from "../../../../../assets/icons/dropdownIcons";
import {Dropdown, notification} from "antd";
import {RoundedCheck} from "../../../../../assets/icons/defaultIcons";
import ThemeModals from "../../../common/modals/theme-modals/ThemeModals";
import ActionModal from "../../../common/modals/action-modal/ActionModal";
import EditArchive from "../../../../views/dashboard/home/pillars/archieves/EditArchive";
import {PillarsService} from "../../../../services/pillars-api.service";
import dayjs from "dayjs";

export default function ArchiveCard ({heading , des , date, id, getListing, setGetListing, modalHeading}) {
    const [editArchive ,setEditArchive] = useState(false);
    const [deleteArchive ,setDeleteArchive] = useState(false);
    const [loader, setLoader] = useState(false)
    const [formattedHeading, setFormattedHeading] = useState([]);
    async function DeleteArchive(id) {
        setLoader(true)
        const response = await PillarsService.deleteArchivePillars(id);
        if(response?.data?.data?.status){
            setGetListing(!getListing)
            notification.success({
                message: "Success",
                description: response?.data?.message,
                placement: "topRight",
                icon: <RoundedCheck/>,
                duration: 2,
            });
            setLoader(false)
        }
        else{
            notification.success({
                message: "Success",
                description: response?.data?.message,
                placement: "topRight",
                icon: <RoundedCheck/>,
                duration: 2,

            });
            setLoader(false)
        }
    }

    // Function to determine if the date is today using dayjs
    function isToday(dateStr) {
        const today = dayjs();
        const dateToCompare = dayjs(dateStr, "DD-MM-YYYY");
        return today.isSame(dateToCompare, 'day');
    }



    const items = [
        {
            key: '1',
            label: <span onClick={()=>{setEditArchive(true)}}><EditIcon/> Edit </span>,
        },
    ];

    if (!isToday(date)) {
        items.push({
            key: '2',
            label: <span onClick={() => setDeleteArchive(true)}><DeleteIcon /> Delete</span>,
        });
    }

    function formatHeading(heading) {
        // Splitting the heading into separate lines on "\\n"
        const lines = heading.split("\\n");
        // Storing the array of lines to be rendered in the component
        setFormattedHeading(lines);
    }

    useEffect(() => {
        formatHeading(heading);
    }, [heading]); // Update on heading changes




    return(
        <div className={'gratitude-card'}>
            <div>
                <h3>
                    {formattedHeading.map((line, index) => (
                        <React.Fragment key={index}>
                            {line}
                            <br />
                        </React.Fragment>
                    ))}
                </h3>
                <p>{des}</p>
            </div>

            <div className={'options'}>
                <div className={'date'}>
                    <span>{date}</span>
                </div>
                <div className={'dots cp'}>
                    <span>
                         <Dropdown menu={{ items }} overlayClassName={'drop-2'} placement="bottomLeft" trigger={'click'}>
                             <TbDots />
                         </Dropdown>
                    </span>
                </div>
            </div>

            <ThemeModals
                open={editArchive}
                close={setEditArchive}
                title={modalHeading}
                content={<EditArchive close={setEditArchive} getListing={getListing} setGetListing={setGetListing} id={id}/>}
            />
            <ActionModal
                show={deleteArchive}
                close={setDeleteArchive}
                modalHeading={'Delete Journal'}
                modalText={'Are you sure you want to delete?'}
                cancelBTnText={'Cancel'}
                actionBTnText={'Delete'}
                // loader={loader}
                actionBtnFunc={()=>{DeleteArchive(id)}}
                loader={loader}
            />
        </div>
    )
}